module.exports = __webpack_public_path__ + "img/collection-weddingRingsPalladium.5785481.jpg";